import React from "react";
import PropTypes from "prop-types";

import { getS3FileKey } from "base/utils";

import styles from "./style.css";

export function Attachment(props) {
  const { column, value } = props;
  return (
    <div className={styles.attachment}>
      {value &&
        Array.isArray(value) &&
        value.length > 0 &&
        value.map((file) => {
          if (file.photos) {
            return (
              <div
                className={`${styles.thumb} ${styles.image} ${
                  column.actionPath ? styles.file : ""
                }`}
                style={
                  !column.actionPath
                    ? {
                        backgroundImage: `url(/upload/2/${getS3FileKey(
                          file.photos?.[2]?.key
                        )})`
                      }
                    : {}
                }
              />
            );
          } else {
            return (
              <div
                className={`${styles.thumb} ${styles.fileIcon} ${styles.file} ${
                  styles[file.fileExtension]
                }`}
              />
            );
          }
        })}
    </div>
  );
}

Attachment.propTypes = {
  value: PropTypes.array,
  column: PropTypes.object
};
